import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { setVolume, setUserInteracted } from 'redux/actions';
import FocusTrap from 'focus-trap-react';
// Page components
import Homepage from 'components/pages/Homepage';
import Beneficiary from 'components/pages/Beneficiary';
import ClaimProcess from 'components/pages/ClaimProcess';
import DeathCertificate from 'components/pages/DeathCertificate';
import SubmitDocumentation from 'components/pages/SubmitDocumentation';
import InsuranceBenefits from 'components/pages/InsuranceBenefits';
import Questions from 'components/pages/Questions';
// Components
import AllAudio from 'components/presentational/AllAudio';
import FirstVisitOverlay from 'components/presentational/FirstVisitOverlay';
import Header from 'components/presentational/Header';
// Files
import 'global/styles/base.scss';

const mapStateToProps = state => {
    return {
        userInteracted: state.userInteracted
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setUserInteracted: () => dispatch(setUserInteracted()),
        setVolume: (val) => dispatch(setVolume(val))
    };
};

class ConnectedApp extends Component {
    constructor() {
        super()

        this.continueClick = this.continueClick.bind(this);
        this.continueNoAudioClick = this.continueNoAudioClick.bind(this);
    }

    continueClick() {
        this.props.setVolume(true);
        this.props.setUserInteracted()
    }

    continueNoAudioClick() {
        this.props.setVolume(false);
        this.props.setUserInteracted();
    }

    render() {
        return ( 
            <Router>
                <> 
                    <AllAudio />
                    { !this.props.userInteracted && 
                        <FocusTrap>
                            <FirstVisitOverlay
                                handleContinue={this.continueClick}
                                handleContinueNoAudio={this.continueNoAudioClick}
                            />
                        </FocusTrap>
                    }
                    
                    <Header />

                    <main className="main">
                        <Switch>
                            <Route 
                                exact path="/beneficiary"
                                render={( props) => (
                                    <Beneficiary 
                                      {...props} 
                                      id={1} 
                                      pageName="For the beneficiary" />
                                )}
                            />
                            <Route 
                                exact path="/step-1" 
                                render={( props) => (
                                    <ClaimProcess  {...props} 
                                      id={2} 
                                      pageName="Step 1: Start the beneficiary claim process" />
                                )}
                            />
                            <Route 
                                exact path="/step-2" 
                                render={( props) => (
                                    <DeathCertificate  {...props} 
                                      id={3}
                                      pageName="Step 2: Obtain the death certificate" />
                                )}
                            />
                            <Route 
                                exact path="/step-3" 
                                render={( props) => (
                                    <SubmitDocumentation  {...props} 
                                      id={4}
                                      pageName="Step 3: Submit your documentation"
                                      nonTca={Boolean(process.env.REACT_APP_NON_TCA)}/>
                                )} 
                            />
                            <Route 
                                exact path="/step-4" 
                                render={( props) => (
                                    <InsuranceBenefits {...props} 
                                      id={5} 
                                      pageName="Step 4: Receive your life insurance benefits"
                                      nonTca={Boolean(process.env.REACT_APP_NON_TCA)}/>
                                )} 
                            />
                            <Route 
                                exact path="/questions" 
                                render={( props) => (
                                    <Questions {...props} 
                                      id={6}
                                      pageName="We’re here for you" />
                                )} 
                            />
                            <Route 
                                exact path="/" 
                                render={( props) => (
                                    <Homepage  {...props} 
                                      id={0} 
                                      pageName="Welcome to the Beneficiary Claims learning tool" />
                                )} 
                            />
                        </Switch>
                    </main>
                </>
            </Router>
        )
    }
}

const App = connect(mapStateToProps, mapDispatchToProps)(ConnectedApp);

export default App;
